
(function() {
  var result = { translations: { "hi": { "i18n": { "duration": { "seconds": "{{ seconds }} \u0938\u0947\u0915\u0902\u0921", "minutes": "{{ minutes }} \u092E\u093F\u0928\u091F", "hours": "{{ hours }} \u0918\u0902\u091F\u093E", "hoursAndMinutes": "{{ hours }} \u0918\u0902\u091F\u093E {{ minutes }} \u092E\u093F\u0928\u091F", "days": "{{ days }} \u0926\u093F\u0928", "shortForm": { "seconds": "{{ seconds }}\u0938\u0947", "minutes": "{{ minutes }}\u092E\u093F", "hours": "{{ hours }}\u0918\u0902", "days": "{{ days }}\u0926\u093F", "hoursAndMinutes": "{{ hours }}\u0918\u0902 {{ minutes }}\u092E\u093F" } }, "dateTime": { "quarterAndYear": "\u0915\u094D\u0935\u093E{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "hi": "static-7.1205"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1205",
    "ar-eg": "static-7.1205",
    "bg": "static-7.1205",
    "bn": "static-7.1205",
    "ca-es": "static-7.1205",
    "cs": "static-7.1205",
    "da": "static-7.1205",
    "de": "static-7.1205",
    "el": "static-7.1205",
    "en-gb": "static-7.1205",
    "en": "static-7.1205",
    "es-mx": "static-7.1205",
    "es": "static-7.1205",
    "et": "static-7.1205",
    "fi": "static-7.1205",
    "fr-ca": "static-7.1205",
    "fr": "static-7.1205",
    "he-il": "static-7.1205",
    "hi": "static-7.1205",
    "hr": "static-7.1205",
    "hu": "static-7.1205",
    "id": "static-7.1205",
    "it": "static-7.1205",
    "ja": "static-7.1205",
    "ko": "static-7.1205",
    "lt": "static-7.1205",
    "ms": "static-7.1205",
    "nl": "static-7.1205",
    "no": "static-7.1205",
    "pl": "static-7.1205",
    "pt-br": "static-7.1205",
    "pt-pt": "static-7.1205",
    "ro": "static-7.1205",
    "ru": "static-7.1205",
    "sk": "static-7.1205",
    "sl": "static-7.1205",
    "sv": "static-7.1205",
    "th": "static-7.1205",
    "tl": "static-7.1205",
    "tr": "static-7.1205",
    "uk": "static-7.1205",
    "vi": "static-7.1205",
    "x-pseudo": "static-7.1205",
    "zh-cn": "static-7.1205",
    "zh-hk": "static-7.1205",
    "zh-tw": "static-7.1205"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:hi', {version: 'static-7.1205'}); }
})();


